import { useColorModeValue } from '@chakra-ui/color-mode';
import { Box, Button, Flex, Heading, Text, Grid, VStack } from '@chakra-ui/react';
import React, { useContext, useEffect, useState, useCallback } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { requestServerApi, serverApi } from '../../api/api';
import '../../assets/styles/index.scss';
import { getFormattedDate, getFormattedTime } from '../../components/Format';
import useErrorPage from '../../hooks/useErrorPage/useErrorPage';
import { currentUserId } from '../shell';
import './index.scss';
import LearnerInfo from './LearnerInfo';
import StoryStudyHistoryModal from './Modal/StudyHistoryModal/Story/StoryStudyHistoryModal';
import SelfStudyHistoryModal from './Modal/StudyHistoryModal/SelfStudy/SelfStudyHistoryModal';
import LessonModal from './Modal/LessonModal/LessonModal';
import LessonsModal from '../lessons/Modal/LessonsModal/LessonsModal';

export type code = {
  id: number;
  status: string;
  teacher: string;
  start_datetime: string;
  end_datetime: string;
};
export const getFormattedLessonTime = (lessonFrame: any) => {
  return lessonFrame && Object.keys(lessonFrame).length > 0
    ? `${getFormattedDate(lessonFrame.start_datetime, true)}`
    : '';
};

export const FieldNames = {
  Story_010: 'ストーリー',
  Story_020: '回数',
  Story_030: '初回開始',
  Story_040: '初回終了',
  Story_050: '最終学習日',
  Talk_010: '話す',
  Talk_020: 'レッスン出席回数',
  Talk_030: 'レッスン欠席回数',
  Talk_040: 'レッスン出席率',
  Talk_050: 'レッスン合計時間',
  Talk_060: 'レッスン回数',
  Self_010: '自習',
  Self_020: '直近3回の平均',
  Self_030: '回数',
  Self_040: 'ドリル',
  Common_001: '学習済み',
  Common_002: '学習中',
  Common_003: '未学習',
};
function Index() {
  const learner_id: string = useParams<any>().learnerId;
  const company_id: string = useParams<any>().companyId;
  const history = useHistory();
  const [refreshFlg, setRefreshFlg] = useState<any>([]);

  const teacher_id = useContext(currentUserId);
  const { apiErrorHandler } = useErrorPage();
  const [paymentLearner, setPaymentLearner] = useState<any>({});
  const [learnerPaymentInfo, setLearnerPaymentInfo] = useState<any>({});
  const [dailyDurationSession, setDailyDurationSession] = useState<any[]>([]);
  const [totalDuration, setTotalDuration] = useState<number>(0);
  const [totalLessons, setTotalLessons] = useState<number>(0);
  const [participatedLessons, setParticipatedLessons] = useState<number>(0);
  const [activeTab, setActiveTab] = useState('learningHistory');
  const [modalData, setModalData] = useState<any>({});
  const [lastPastLesson, setLastPastLesson] = useState<any>({});

  const getLearnerDetail = useCallback(() => {
    // 学習者情報
    const apiResponse = requestServerApi<any>(() =>
      serverApi
        .organizationsControllerGetPaymentLearnerDetails(company_id, -1, learner_id)
        .catch((e) =>
          apiErrorHandler(e, {
            componentName: 'learner',
            functionName: serverApi.organizationsControllerGetPaymentLearnerDetails.name,
          }),
        ),
    );
    apiResponse.then((result) => {
      if (result.data !== undefined && result?.data?.data) {
        const rawData = result?.data?.data;
        const paymentLearnerInfoData = Array.isArray(rawData?.[0]) ? rawData[0] : [];
        const paymentLearnerData = paymentLearnerInfoData?.[0] || {};

        setPaymentLearner(paymentLearnerData);
        setLearnerPaymentInfo(paymentLearnerInfoData);
        setDailyDurationSession(paymentLearnerData.dailyDurationsSession || []);
        setTotalDuration(paymentLearnerData.totalStudyDuration || 0);
        setTotalLessons(paymentLearnerData.totalLessons || 0);
        setParticipatedLessons(paymentLearnerData.participatedLessons || 0);
      }
    });
  }, [company_id, learner_id, apiErrorHandler]);

  //get past lesson
  const getPastLesson = useCallback(() => {
    const apiResponse = requestServerApi<any>(() =>
      serverApi
        .organizationsControllerGetPastLessonListBgd(
          company_id,
          teacher_id,
          '',
          '',
          '',
          learner_id,
          '',
          '',
          1,
          1,
        )
        .catch((e) =>
          apiErrorHandler(e, {
            componentName: 'learner',
            functionName: serverApi.organizationsControllerGetPastLessonListBgd.name,
          }),
        ),
    );
    apiResponse.then((data) => {
      const lessons = data.data?.data?.[0] || [];
      const matchedLesson = lessons.find((lesson: { t_lesson_learner: any[] }) =>
        lesson.t_lesson_learner?.some((ll: any) => {
          return ll.m_learner?.learner_id === learner_id;
        }),
      );
      if (matchedLesson) {
        matchedLesson.t_lesson_learner = matchedLesson.t_lesson_learner.filter(
          (ll: { m_learner: { learner_id: string } }) => ll.m_learner?.learner_id === learner_id,
        );
      }
      setLastPastLesson(matchedLesson);
    });
  }, [company_id, teacher_id, learner_id, apiErrorHandler]);

  const onClickLastLessonHistory = async () => {
    if (!lastPastLesson || Object.keys(lastPastLesson).length === 0) {
      setModalData({});
      onOpenModal('lessonModal', {});
      return;
    }

    const modalData: any = {
      lesson_day: getFormattedDate(lastPastLesson?.start_datetime, true),
      start_time: getFormattedTime(lastPastLesson?.start_datetime),
      end_time: getFormattedTime(lastPastLesson?.end_datetime),
      teacher: lastPastLesson?.t_lesson_teacher[0].m_teacher.full_name,
      note: lastPastLesson?.note,
      feedback: lastPastLesson?.t_lesson_learner[0]?.feed_back,
    };

    setModalData(modalData);
    onOpenModal('lessonModal', modalData);
  };

  const onClickLessons = async () => {
    const modalData: any = {
      company_id: company_id,
      learner_id: learner_id,
    };

    setModalData(modalData);
    onOpenModal('lessonsModal', modalData);
  };

  // 申し送り一覧に遷移して学習者で絞り込み
  const onClickLessonNotes = () => {
    history.push(`/lesson_notes`, {
      company_id: company_id,
      learner_id: learner_id,
      learner_name: paymentLearner?.m_learner?.nick_name,
      company_name: paymentLearner?.m_company?.company_name,
    });
  };

  // フィードバックに遷移して学習者で絞り込み
  const onClickLessonFeedbacks = () => {
    history.push(`/feedback`, {
      company_id: company_id,
      learner_id: learner_id,
      learner_name: paymentLearner?.m_learner?.nick_name,
      company_name: paymentLearner?.m_company?.company_name,
    });
  };

  const isRefreshed = refreshFlg === true;

  useEffect(() => {
    getLearnerDetail();
    setRefreshFlg(false);
  }, [teacher_id, isRefreshed, getLearnerDetail]);

  useEffect(() => {
    if (teacher_id) {
      getPastLesson();
    }
    setRefreshFlg(false);
  }, [teacher_id, isRefreshed, getPastLesson]);

  // Modal切り分け用
  const [selectedModal, setSelectedModal] = useState<string>('');

  // モーダルを開く
  const onOpenModal = (name: string, item: any) => {
    setSelectedModal(name);
  };

  // モーダルを閉じる
  const onCloseModal = () => {
    setSelectedModal('');
  };

  const onCloseResponseModal = (name: string, response: any) => {
    onCloseModal();
  };

  const CustomButton = ({ action, buttonName }: any) => {
    return (
      <Button colorScheme="teal" borderRadius="md" w="400px" onClick={action}>
        {buttonName}
      </Button>
    );
  };

  return (
    <>
      {selectedModal === 'storyStudyHistoryModal' && (
        <StoryStudyHistoryModal onClose={onCloseResponseModal} />
      )}
      {selectedModal === 'selfStudyHistoryModal' && (
        <SelfStudyHistoryModal onClose={onCloseResponseModal} />
      )}
      {selectedModal === 'lessonModal' && (
        <LessonModal modalData={modalData} onClose={onCloseResponseModal} />
      )}
      {selectedModal === 'lessonsModal' && (
        <LessonsModal modalData={modalData} onClose={onCloseResponseModal} />
      )}
      {/* 学習者情報 */}
      <Flex justifyContent="space-between" alignItems={'center'}>
        <Heading mt={5} size="lg" pb="1rem">
          学習者情報
        </Heading>
      </Flex>
      <LearnerInfo
        paymentLearner={paymentLearner}
        dailyDurationSession={dailyDurationSession}
        totalDuration={totalDuration}
        totalLessons={totalLessons}
        participatedLessons={participatedLessons}
      />

      {/* 学習情報 */}
      <Flex my={5} direction="column">
        <Heading size="lg" pb="1rem">
          学習情報
        </Heading>

        <Flex border={`1px solid ${useColorModeValue('#ddd', '#ddd')}`} w="fit-content">
          <Box
            px={8}
            py={2}
            cursor="pointer"
            borderRight={`1px solid ${useColorModeValue('#ddd', '#ddd')}`}
            bg={activeTab === 'learningHistory' ? 'teal.500' : 'white'}
            color={activeTab === 'learningHistory' ? 'white' : 'black'}
            onClick={() => setActiveTab('learningHistory')}
          >
            <Text fontWeight="bold" fontSize="sm">
              学習履歴
            </Text>
          </Box>
          <Box
            px={8}
            py={2}
            cursor="pointer"
            bg={activeTab === 'lessons' ? 'teal.500' : 'white'}
            color={activeTab === 'lessons' ? 'white' : 'black'}
            onClick={() => setActiveTab('lessons')}
          >
            <Text fontWeight="bold" fontSize="sm">
              レッスン
            </Text>
          </Box>
        </Flex>

        <Box border={`1px solid ${useColorModeValue('#ddd', '#ddd')}`} p={8} width="100%" mx="auto">
          {activeTab === 'learningHistory' ? (
            <Grid templateColumns="repeat(2, 1fr)">
              {/* Left Column */}
              <VStack spacing={4}>
                <CustomButton
                  action={() => onOpenModal('storyStudyHistoryModal', '')}
                  buttonName="ストーリー"
                />
              </VStack>

              {/* Right Column */}
              <VStack spacing={4}>
                <CustomButton
                  action={() => onOpenModal('selfStudyHistoryModal', '')}
                  buttonName="自習"
                />
              </VStack>
            </Grid>
          ) : (
            <Flex justifyContent="space-around" flexWrap="wrap" gap={4}>
              <CustomButton
                action={() => onClickLastLessonHistory()}
                buttonName="直近に実施したレッスン"
              />
              {/* <CustomButton action={() => onClickLessonNotes()} buttonName="申し送り事項一覧" /> */}
              <CustomButton action={() => onClickLessons()} buttonName="レッスン一覧" />
              <CustomButton
                action={() => onClickLessonFeedbacks()}
                buttonName="フィードバック一覧"
              />
            </Flex>
          )}
        </Box>
      </Flex>
    </>
  );
}

export default Index;
